export const sites = {
workspace: {
assets: "الأصول",
sites: "المواقع",
},
list: {
  showAllSites: "عرض كل المواقع",
  emptyArchivedSub: "تُحفظ المواقع التي تؤرشفها هنا. افتح موقعاً لاستعادته.",
  emptyArchivedTitle: "لا توجد مواقع مؤرشفة",
  queueArchived: "المؤرشفة",
title: "المواقع",
subtitle_one: "{{count}} موقع",
subtitle_other: "{{count}} موقع",
searchPlaceholder: "البحث في المواقع…",
searchA11y: "البحث في المواقع",
refine: "تصفية",
refineSheetTitle: "تصفية المواقع",
addSite: "إضافة موقع",
queueAll: "الكل",
queueAttention: "معرّض للخطر",
queueDevelopment: "قيد التطوير",
nextReviewAtRisk_one: "مراجعة أصل واحد معرّض للخطر",
nextReviewAtRisk_other: "مراجعة {{count}} أصل معرّض للخطر",
nextOpenJobs_one: "أمر عمل مفتوح واحد",
nextOpenJobs_other: "{{count}} أمر عمل مفتوح",
nextOpenChecks_one: "فحص مفتوح واحد",
nextOpenChecks_other: "{{count}} فحص مفتوح",
a11yAssets_one: "{{count}} أصل",
a11yAssets_other: "{{count}} أصل",
emptyTitle: "لا توجد مواقع حتى الآن",
createSite: "إنشاء موقع",
emptySub: "أنشئ موقعًا لتجميع الأصول حسب الموقع أو المحفظة.",
emptyFilterTitle: "لا توجد مواقع مطابقة",
emptyFilterSub: "جرّب مصطلحات بحث مختلفة أو مسح المرشحات.",
clearFilters: "مسح المرشحات",
typeChip: "النوع",
lifecycleChip: "الحالة",
sortChip: "الترتيب",
sortNameAsc: "الاسم أ-ي",
sortNameDesc: "الاسم ي-أ",
sortNewest: "الأحدث",
sortOldest: "الأقدم",
insightAttention: "{{count}} معرّض للخطر",
nextAllClear: "لا يوجد عمل مفتوح",
nextAddAssets: "إضافة أصول إلى هذا الموقع",
pillAsset: "أصل",
pillAssets: "أصول",
pillOnTrack: "على المسار الصحيح",
pillJobs: "أوامر عمل",
pillChecks: "فحوصات",
exportCsv: "تصدير CSV",
exportCsvA11y: "تنزيل المواقع كملف CSV",
viewCards: "عرض البطاقات",
viewTable: "عرض الجدول",
openSite: "فتح الموقع",
unassigned: "غير معيَّن",
managingTeam: "الفريق المسؤول",
colSite: "الموقع",
colType: "النوع",
colTeam: "الفريق",
colAssets: "الأصول",
colJobs: "أوامر العمل",
colRisk: "معرّض للخطر",
colStatus: "الحالة",
unknownSite: "موقع غير معروف",
loadErrorTitle: "تعذر تحميل مواقعك",
loadErrorBlockedTitle: "لا يمكن عرض المواقع",
viewLabel: "العرض",
scopeLabel: "النطاق",
csvHeaderName: "الاسم",
csvHeaderCode: "المرجع",
csvHeaderLifecycle: "الحالة",
csvHeaderAddress: "العنوان",
subtitle_zero: "لا مواقع",
subtitle_two: "موقعان",
subtitle_few: "{{count}} مواقع",
subtitle_many: "{{count}} موقعًا",
nextReviewAtRisk_zero: "لا أصول معرّضة للخطر للمراجعة",
nextReviewAtRisk_two: "مراجعة أصلين معرّضين للخطر",
nextReviewAtRisk_few: "مراجعة {{count}} أصول معرّضة للخطر",
nextReviewAtRisk_many: "مراجعة {{count}} أصلًا معرّضًا للخطر",
nextOpenJobs_zero: "لا أوامر عمل مفتوحة",
nextOpenJobs_two: "أمرا عمل مفتوحان",
nextOpenJobs_few: "{{count}} أوامر عمل مفتوحة",
nextOpenJobs_many: "{{count}} أمرَ عمل مفتوحًا",
nextOpenChecks_zero: "لا فحوصات مفتوحة",
nextOpenChecks_two: "فحصان مفتوحان",
nextOpenChecks_few: "{{count}} فحوصات مفتوحة",
nextOpenChecks_many: "{{count}} فحصًا مفتوحًا",
a11yAssets_zero: "لا أصول",
a11yAssets_two: "أصلان",
a11yAssets_few: "{{count}} أصول",
a11yAssets_many: "{{count}} أصلًا",
},
detail: {
byPlaceTitle: "حسب المبنى",
byPlaceOpenA11y: "فتح {{name}}",
byPlaceInside_zero: "لا شيء في الداخل",
byPlaceInside_one: "عنصر واحد في الداخل",
byPlaceInside_two: "عنصران في الداخل",
byPlaceInside_few: "{{count}} عناصر في الداخل",
byPlaceInside_many: "{{count}} عنصرًا في الداخل",
byPlaceInside_other: "{{count}} عنصر في الداخل",
byPlaceOpenJobs_zero: "لا أعمال مفتوحة",
byPlaceOpenJobs_one: "عمل مفتوح",
byPlaceOpenJobs_two: "عملان مفتوحان",
byPlaceOpenJobs_few: "{{count}} أعمال مفتوحة",
byPlaceOpenJobs_many: "{{count}} عملًا مفتوحًا",
byPlaceOpenJobs_other: "{{count}} عمل مفتوح",
byPlaceDue_zero: "لا زيارات مستحقة",
byPlaceDue_one: "زيارة مستحقة",
byPlaceDue_two: "زيارتان مستحقتان",
byPlaceDue_few: "{{count}} زيارات مستحقة",
byPlaceDue_many: "{{count}} زيارة مستحقة",
byPlaceDue_other: "{{count}} زيارة مستحقة",
byPlaceAtRisk_zero: "لا شيء بخطر مرتفع",
byPlaceAtRisk_one: "واحد بخطر مرتفع",
byPlaceAtRisk_two: "اثنان بخطر مرتفع",
byPlaceAtRisk_few: "{{count}} بخطر مرتفع",
byPlaceAtRisk_many: "{{count}} بخطر مرتفع",
byPlaceAtRisk_other: "{{count}} بخطر مرتفع",
  noWorkNoAssets: "يظهر العمل هنا عندما تكون للموقع أصول. أضف أصلاً أو انقل واحداً إلى هنا.",
  assignSubtitleTeam: "اختر أصلاً لنقله إلى هنا. سيغادر أي موقع آخر وينتقل إلى {{team}}.",
  assignSubtitle: "اختر أصلاً لنقله إلى هنا. سيغادر أي موقع آخر يوجد فيه.",
  assignFailedBody: "لم يتم نقل الأصل. تحقق من اتصالك وحاول مرة أخرى.",
  assignRefusedBody: "لا يمكنك نقل هذا الأصل. اطلب ذلك من مسؤوله أو من أحد المشرفين.",
  assignFailedTitle: "لم يتم نقل الأصل",
  assignedFallbackAsset: "الأصل",
  assignedToast: "تم نقل {{asset}} إلى {{site}}.",
  archivedBanner: "هذا الموقع مؤرشف ومخفي من مواقعك. استعده لاستخدامه مرة أخرى.",
  archivedPill: "مؤرشف",
  restoredToast: "تمت استعادة {{name}}. عاد إلى مواقعك.",
  archivedToast: "تمت أرشفة {{name}}. ستجده ضمن المؤرشفة في المواقع.",
loading: "جارٍ تحميل الموقع…",
addAsset: "إضافة أصل",
createAsset: "إضافة أصل",
assignAsset: "تعيين أصل",
assignExistingAsset: "تعيين أصل موجود",
siteOptions: "خيارات الموقع",
edit: "تعديل",
tabOverview: "نظرة عامة",
tabDetails: "التفاصيل",
tabAssets: "الأصول",
tabWork: "العمل",
tabReports: "التقارير",
tabEsg: "ESG",
tabContacts: "جهات الاتصال",
tabActivity: "النشاط",
tabPeople: "الأشخاص",
refine: "تصفية",
view: "العرض",
viewList: "قائمة",
viewMap: "خريطة",
viewNetwork: "الشبكة",
filterAttention: "يحتاج إلى اهتمام",
backToOverview: "العودة إلى النظرة العامة",
kpiAssets: "الأصول",
kpiAtRisk: "معرّض للخطر",
kpiOpenJobs: "أوامر العمل المفتوحة",
kpiOpenInspections: "التفتيشات المفتوحة",
parentSite: "الموقع الأصل",
childSites: "المواقع الفرعية",
description: "الوصف",
noAssets: "لا توجد أصول في هذا الموقع.",
noAssetsForFilter: "لا توجد أصول مطابقة لهذا المرشح.",
noWork: "لا توجد أوامر عمل أو فحوصات مفتوحة.",
noContacts: "لا توجد جهات اتصال مرتبطة حتى الآن.",
noContactsNeedAssets: "أضف أصولًا قبل ربط جهات الاتصال.",
noActivity: "لا يوجد نشاط حديث.",
linkContact: "ربط جهة اتصال",
selectAssetForContact: "اختر أصلًا لجهة الاتصال",
linkContactTitle: "ربط جهة اتصال بأصل الموقع",
cancel: "إلغاء",
filterAll: "الكل",
openJobs: "أوامر العمل المفتوحة",
openInspections: "التفتيشات المفتوحة",
attentionAssets_zero: "لا أصول تحتاج إلى اهتمام",
attentionAssets_one: "أصل واحد يحتاج إلى اهتمام",
attentionAssets_two: "أصلان يحتاجان إلى اهتمام",
attentionAssets_few: "{{count}} أصول تحتاج إلى اهتمام",
attentionAssets_many: "{{count}} أصلًا يحتاج إلى اهتمام",
attentionAssets_other: "{{count}} أصل يحتاج إلى اهتمام",
openJobsCount_zero: "لا أوامر عمل مفتوحة",
openJobsCount_one: "أمر عمل مفتوح واحد",
openJobsCount_two: "أمرا عمل مفتوحان",
openJobsCount_few: "{{count}} أوامر عمل مفتوحة",
openJobsCount_many: "{{count}} أمر عمل مفتوحًا",
openJobsCount_other: "{{count}} أمر عمل مفتوح",
assetsSectionTitle: "الأصول في هذا الموقع",
assetsSectionSub_one: "{{count}} أصل",
assetsSectionSub_other: "{{count}} أصل",
filterVehicles: "المركبات",
descriptionSummary: "ملاحظات الموقع وسياقه",
workBannerNamed: "العمل مقيَّد بـ {{names}}",
contactsForAsset_one: "جهة اتصال واحدة",
contactsForAsset_other: "{{count}} جهة اتصال",
noContactsForAsset: "لا توجد جهات اتصال مرتبطة بهذا الأصل حتى الآن.",
archiveConfirmTitle: "هل ترغب في أرشفة هذا الموقع؟",
archiveConfirmMessage: "سيُخفى من مواقعك. تبقى الأصول في مكانها. ستجده ضمن المؤرشفة في المواقع ويمكنك استعادته.",
archive: "أرشفة",
archiveFailedTitle: "تعذر أرشفة الموقع",
archiveFailedMessage: "لم يتغير الموقع. تحقق من اتصالك وحاول مرة أخرى.",
restore: "استعادة الموقع",
restoreFailedTitle: "تعذر استعادة الموقع",
loadErrorTitle: "لم نتمكن من تحميل هذا الموقع",
loadErrorBlockedTitle: "لا يمكن عرض هذا الموقع",
goBack: "رجوع",
notFoundTitle: "لم يتم العثور على الموقع",
notFoundBody: "ربما تمت أرشفة هذا الموقع، أو أن الرابط قديم.",
noAssetsForSearch: "لا توجد أصول تطابق بحثك",
clearSearch: "مسح البحث",
searchAssetsPlaceholder: "ابحث عن الأصول في هذا الموقع",
kpiAttention: "بحاجة إلى اهتمام",
kpiOpenChecks: "الفحوصات المفتوحة",
kpiAssetsInfoDescription: "الأصول المخصصة لهذا الموقع. تُحتسب أصول المواقع الفرعية ضمن تلك المواقع.",
kpiAssetsInfoBasedOn_zero: "{{count}} أصل، محسوبة مباشرة من سجل الأصول",
kpiAssetsInfoBasedOn_one: "أصل واحد، محسوبة مباشرة من سجل الأصول",
kpiAssetsInfoBasedOn_two: "أصلان، محسوبة مباشرة من سجل الأصول",
kpiAssetsInfoBasedOn_few: "{{count}} أصول، محسوبة مباشرة من سجل الأصول",
kpiAssetsInfoBasedOn_many: "{{count}} أصلًا، محسوبة مباشرة من سجل الأصول",
kpiAssetsInfoBasedOn_other: "{{count}} أصل، محسوبة مباشرة من سجل الأصول",
kpiAttentionInfoDescription: "الأصول الموجودة في هذا الموقع والتي تكون حالتها الصحية تحت المراقبة أو الضعيفة، أو التي تحمل أعمالًا متأخرة.",
kpiAttentionInfoBasedOn: "{{count}} من إجمالي {{total}} من الأصول، وفق الحالة الصحية الحالية لكل أصل",
kpiJobsInfoDescription: "أوامر العمل على الأصول الموجودة في هذا الموقع والتي لم يتم إكمالها أو التحقق منها بعد.",
kpiJobsInfoBasedOn_zero: "{{count}} أمر عمل مفتوح عبر {{total}} أصل",
kpiJobsInfoBasedOn_one: "أمر عمل مفتوح واحد عبر {{total}} أصل",
kpiJobsInfoBasedOn_two: "أمرا عمل مفتوحان عبر {{total}} أصل",
kpiJobsInfoBasedOn_few: "{{count}} أوامر عمل مفتوحة عبر {{total}} أصل",
kpiJobsInfoBasedOn_many: "{{count}} أمرَ عمل مفتوحًا عبر {{total}} أصل",
kpiJobsInfoBasedOn_other: "{{count}} أمر عمل مفتوح عبر {{total}} أصل",
kpiChecksInfoDescription: "عمليات التفتيش على الأصول الموجودة في هذا الموقع والتي لا تزال مفتوحة: بدأت ولم تكتمل، أو تمت جدولتها ولم يتم تنفيذها بعد.",
kpiChecksInfoBasedOn_zero: "{{count}} تفتيش مفتوح عبر {{total}} أصل",
kpiChecksInfoBasedOn_one: "تفتيش مفتوح واحد عبر {{total}} أصل",
kpiChecksInfoBasedOn_two: "تفتيشان مفتوحان عبر {{total}} أصل",
kpiChecksInfoBasedOn_few: "{{count}} تفتيشات مفتوحة عبر {{total}} أصل",
kpiChecksInfoBasedOn_many: "{{count}} تفتيشًا مفتوحًا عبر {{total}} أصل",
kpiChecksInfoBasedOn_other: "{{count}} تفتيش مفتوح عبر {{total}} أصل",
factsTitle: "التفاصيل",
factCode: "رمز الموقع",
factCategory: "الفئة",
factType: "النوع",
factStatus: "الحالة",
factAddress: "العنوان",
factTeam: "الفريق المسؤول",
factContacts: "جهات الاتصال",
factHolds: "يضم",
factCreated: "تاريخ الإنشاء",
factUpdated: "آخر تحديث",
factNotSet: "غير محدد",
factViewOnMap: "عرض على الخريطة",
assetsSectionSub_zero: "لا أصول",
assetsSectionSub_two: "أصلان",
assetsSectionSub_few: "{{count}} أصول",
assetsSectionSub_many: "{{count}} أصلًا",
contactsForAsset_zero: "لا جهات اتصال",
contactsForAsset_two: "جهتا اتصال",
contactsForAsset_few: "{{count}} جهات اتصال",
contactsForAsset_many: "{{count}} جهة اتصال",
    tabDocuments: "المستندات",
    factFloorArea: "المساحة",
    floorAreaValue: "{{value}} م²",
},
map: {
  unavailableSub: "تعذر تحميل الخريطة. تحقق من اتصالك وحاول مرة أخرى.",
  addSiteAddress: "أضف عنوان الموقع",
noAssetsTitle: "لا توجد أصول في هذا الموقع",
noAssetsSub: "أضف أصولًا لرؤيتها على الخريطة.",
noCoordinatesTitle: "لا شيء على الخريطة بعد",
noCoordinatesSub: "أضف عنوان الموقع أو عناوين أصوله لتظهر هنا.",
unavailableTitle: "الخريطة غير متاحة",
coverageShown_zero: "لا أصول محددة على الخريطة.",
coverageShown_one: "عرض أصل واحد محدد على الخريطة.",
coverageShown_two: "عرض أصلين محددين على الخريطة.",
coverageShown_few: "عرض {{count}} أصول محددة على الخريطة.",
coverageShown_many: "عرض {{count}} أصلًا محددًا على الخريطة.",
coverageShown_other: "عرض {{count}} أصل محدد على الخريطة.",
coverageHidden_zero: "لا شيء مخفي.",
coverageHidden_one: "واحد مخفي بلا إحداثيات.",
coverageHidden_two: "اثنان مخفيان بلا إحداثيات.",
coverageHidden_few: "{{count}} مخفية بلا إحداثيات.",
coverageHidden_many: "{{count}} مخفيًا بلا إحداثيات.",
coverageHidden_other: "{{count}} مخفي بلا إحداثيات.",
boundarySaveFailedTitle: "تعذر حفظ الحدود",
boundarySaveFailedBody: "تعذّر حفظ حدود الموقع.",
boundaryRedraw: "إعادة رسم الحدود",
boundaryDraw: "رسم الحدود",
boundaryRemove: "إزالة",
boundarySave: "حفظ الحدود",
boundaryUndo: "تراجع",
boundaryTapFirstCorner: "اضغط على الخريطة لوضع الزاوية الأولى",
boundaryCornersAdjust: "الزوايا: {{count}} — اسحب أيًّا منها لضبطها",
boundaryCornersOfThree: "{{count}} من 3 زوايا",
},
network: {
noAssetsTitle: "لا توجد أصول للربط",
noAssetsSub: "أضف أصلين على الأقل لاستكشاف العلاقات.",
singleAssetTitle: "أصل واحد في هذا الموقع",
singleAssetSub: "اربط هذا الأصل بأصول أخرى من صفحة تفاصيله لبناء شبكة.",
openAsset: "فتح الأصل",
},
assetLink: {
label: "الموقع",
helper: "المكان الذي يوجد فيه هذا الأصل.",
none: "لا يوجد موقع معيَّن",
open: "فتح الموقع",
rowHelper: "اختياري. المكان الذي يوجد فيه هذا الأصل.",
a11ySelected: "الموقع: {{name}}. تغيير الموقع.",
a11yUnselected: "حدد الموقع، اختياري",
clearSite: "مسح الموقع",
selectSite: "اختر الموقع",
},
kind: {
  status: {
    decommissioned: "خارج الخدمة",
    under_renovation: "قيد التجديد",
    partially_operational: "قيد الاستخدام جزئياً",
    operational: "قيد الاستخدام",
    handover: "قيد التسليم",
    partially_developed: "مبني جزئياً",
    in_development: "قيد الإنشاء",
    planned: "مخطط",
  },
  type: {
    other: "أخرى",
    building: "مبنى",
    corridor: "مسار (طريق أو سكة أو خط أنابيب)",
    data_centre: "مركز بيانات",
    hotel: "فندق",
    hospital: "مستشفى",
    airport: "مطار",
    shopping_centre: "مركز تسوق",
    substation: "محطة كهرباء فرعية",
    project_site: "موقع مشروع",
    construction_site: "موقع بناء",
    parking_facility: "موقف سيارات",
    terminal: "محطة طرفية",
    port: "ميناء",
    distribution_centre: "مركز توزيع",
    warehouse: "مخزن",
    workshop: "ورشة",
    fleet_hub: "مركز الأسطول",
    garage: "مرآب",
    yard: "ساحة",
    depot: "مستودع",
    plant: "محطة",
    factory: "مصنع",
    industrial_park: "منطقة صناعية",
    office_building: "مبنى مكاتب",
    campus: "حرم",
    retail_park: "مجمع تجاري",
    business_park: "مجمع أعمال",
    scheme: "مشروع سكني",
    neighbourhood: "حي",
    estate: "مجمع سكني",
  },
  category: {
    other: "أخرى",
    mixed_use: "استخدام مختلط",
    healthcare: "رعاية صحية",
    hospitality: "ضيافة",
    temporary: "مؤقت / مشروع",
    infrastructure: "البنية التحتية",
    logistics: "الخدمات اللوجستية والتخزين",
    fleet_transport: "الأسطول والنقل",
    industrial: "صناعي",
    commercial: "تجاري",
    residential: "سكني",
  },
  statusLabel: "الحالة",
  typeLabel: "أيها الأنسب؟",
  categoryLabel: "ما نوع هذا المكان؟",
},
create: {
  createdBackToAsset: "تم إنشاء {{name}} واختياره لأصلك.",
  created: "تم إنشاء {{name}}. أضف أصوله من هنا.",
  unsavedGuardMessage: "لم تحفظ هذا الموقع. هل تريد المغادرة وفقدان ما كتبته؟",
pageTitle: "موقع جديد",
newSiteKicker: "موقع جديد",
unnamedSite: "موقع بلا اسم",
addNotesFirstTitle: "أضف الملاحظات أولاً",
addNotesFirstBody: "اكتب مسودة قصيرة أو أملِها، ثم استخدم «تحسين باستخدام الذكاء الاصطناعي».",
improvedSiteNotesTitle: "ملاحظات الموقع المحسّنة",
unableToImproveNotesTitle: "غير قادر على تحسين الملاحظات",
improveNotesRationale: "قم بمراجعة الملاحظات المحسنة قبل تطبيقها على الموقع.",
improveNotesFailed: "تعذر تحسين الملاحظات. يرجى المحاولة مرة أخرى.",
nameRequiredTitle: "الاسم مطلوب",
nameRequiredBody: "اكتب اسماً للموقع.",
invalidTypeTitle: "اختر النوع مرة أخرى",
invalidTypeBody: "هذا النوع لا يناسب نوع المكان الذي اخترته. اختر واحداً من القائمة.",
createFailedTitle: "تعذر إنشاء الموقع",
createFailedBody: "لم يتم إنشاء الموقع. تحقق من اتصالك وحاول مرة أخرى.",
labelType: "نوع الموقع",
labelLifecycle: "الحالة",
labelParent: "الموقع الأصل",
labelManagingTeam: "الفريق المسؤول",
labelAddress: "العنوان",
labelName: "الاسم",
labelCode: "المرجع",
fallbackDash: "—",
basicsNameLabel: "الاسم *",
siteNameA11y: "اسم الموقع (مطلوب)",
siteNamePlaceholder: "مثال: مجمع أوكوود",
codeLabel: "المرجع (اختياري)",
codeHint: "رمزك القصير لهذا الموقع، إن كنت تستخدم واحداً.",
codeA11y: "المرجع (اختياري)",
codePlaceholder: "مثال: NDEP-01",
parentSiteLabel: "الموقع الأصل",
parentSiteHelper: "اختياري. ضعه داخل مجمع أو مستودع أو حرم.",
managingTeamHelper: "الأصول التي تضيفها إلى هذا الموقع تنتقل إلى هذا الفريق.",
addressLabel: "العنوان (اختياري)",
descriptionLabel: "الوصف (اختياري)",
descriptionA11y: "الوصف (اختياري)",
descriptionPlaceholder: "ملاحظات الوصول أو تفاصيل المرحلة أو سياق التسليم",
dictate: "إملاء",
stopDictation: "إيقاف",
improving: "جارٍ التحسين...",
improveWithAi: "تحسين باستخدام الذكاء الاصطناعي",
stepBasicsTitle: "الأساسيات",
stepBasicsWhy: "أدخل اسماً للموقع. هذا كل ما تحتاجه، والباقي اختياري.",
stepLocationTitle: "أين هو؟",
stepLocationWhy: "أضف العنوان ليتمكن الآخرون من الوصول إليه.",
stepClassifyTitle: "نوع الموقع",
stepClassifyWhy: "حدد نوع المكان وما إذا كان قيد الاستخدام.",
stepStructureTitle: "الموقع الرئيسي والفريق",
stepStructureWhy: "ضعه داخل موقع أكبر، واختر الفريق المسؤول عنه.",
saving: "جارٍ الحفظ…",
createSite: "إنشاء الموقع",
parentSiteModalTitle: "الموقع الأصل",
managingTeamModalTitle: "الفريق المسؤول",
},
team: {
managingTeam: "الفريق المسؤول",
managingTeamHelper: "ترث الأصول في هذا الموقع هذا الفريق عند إضافتها أو عند تغييره هنا.",
selectTeam: "اختر فريقًا",
optional: "اختياري",
pickerTitle: "الفريق المسؤول",
noneAssigned: "لا يوجد فريق معيَّن",
cascadeConfirmTitle: "تحديث فرق الأصول؟",
cascadeConfirmMessage_one: "سيُعاد تعيين أصل واحد في هذا الموقع إلى {{team}}.",
cascadeConfirmMessage_other: "سيُعاد تعيين {{count}} أصل في هذا الموقع إلى {{team}}.",
cascadeConfirmAction: "تحديث الفريق",
updateFailedTitle: "تعذّر تحديث الفريق",
updateFailedMessage: "حاول مرة أخرى.",
rowHelper: "ترث الأصول المضافة إلى هذا الموقع إسناد هذا الفريق.",
a11ySelected: "الفريق المسؤول: {{name}}. تغيير الفريق.",
a11yUnselected: "حدد فريق الإدارة، اختياري",
clearTeam: "مسح الفريق",
cascadeConfirmMessage_zero: "لا أصول في هذا الموقع لإعادة تعيينها إلى {{team}}.",
cascadeConfirmMessage_two: "سيُعاد تعيين أصلين في هذا الموقع إلى {{team}}.",
cascadeConfirmMessage_few: "سيُعاد تعيين {{count}} أصول في هذا الموقع إلى {{team}}.",
cascadeConfirmMessage_many: "سيُعاد تعيين {{count}} أصلًا في هذا الموقع إلى {{team}}.",
},
picker: {
dismissA11y: "إغلاق منتقي الموقع",
closeA11y: "إغلاق منتقي الموقع",
searchPlaceholder: "البحث في المواقع...",
loadingSites: "جارٍ تحميل المواقع",
emptyResults: "لم يتم العثور على أي مواقع. أنشئ واحدًا أدناه أو قم بالإلغاء للرجوع.",
selectItemA11y: "حدد {{name}}",
},
report: {
placeTitle: "{{place}} · {{site}}",
  generateFailedBody: "حدث خطأ ما. حاول مرة أخرى بعد دقيقة.",
  shareFailedTitle: "تعذّر حفظ التقرير",
  shareGenerated: "كتبه الذكاء الاصطناعي في {{date}}. راجعه قبل الاعتماد عليه.",
  shareTitle: "تقرير الموقع: {{name}}",
  pdfDocType: "تقرير الموقع",
  pdfSummary: "ملخص الموقع",
  pdfType: "نوع الموقع",
  pdfStatus: "الحالة",
  pdfTeam: "الفريق المسؤول",
  pdfAddress: "العنوان",
  pdfAssetCount: "الأصول",
  pdfAssetsHeading: "الأصول في هذا الموقع",
  pdfColAsset: "الأصل",
  pdfColType: "نوع الأصل",
  pdfColStatus: "الحالة",
  sharePdf: "حفظ أو مشاركة كملف PDF",
  internetResearchHint: "إيقاف: يستخدم التقرير سجلاتك فقط. تشغيل: يبحث أيضًا في الويب، مثل عمليات الاستدعاء لهذه العلامة والطراز.",
  internetResearchA11y: "البحث أيضًا عن معلومات عامة عبر الإنترنت",
  internetResearch: "البحث أيضًا عن معلومات عامة عبر الإنترنت",
loadHistoryFailedTitle: "غير قادر على تحميل سجل التقرير",
unknownError: "خطأ غير معروف",
selectAnalysisTypeTitle: "حدد نوع تحليل واحد على الأقل",
selectAnalysisTypeBody: "اختر قسمًا واحدًا أو أكثر قبل إنشاء التقرير.",
generateFailedTitle: "لم يُنشأ تقرير الموقع",
summaryPlaceholder: "قم بإنشاء أو تحميل تقرير موقع متقدم لمعرفة مخاطر المحفظة والصحة والامتثال والتوصيات عبر كل أصل في هذا الموقع.",
actionSelectType: "حدد نوع تحليل واحد على الأقل.",
actionGenerate: "أنشئ تقرير الموقع.",
analysisSiteOverview: "نظرة عامة على الموقع",
analysisAssets: "الأصول",
analysisMaintenance: "الصيانة",
analysisRisk: "المخاطر",
analysisHealth: "الصحة",
analysisCompliance: "الامتثال",
analysisComparisons: "المقارنات",
contextBadge: "تقرير بالذكاء الاصطناعي",
fallbackTitle: "تقرير الموقع",
metaKind: "تقرير بالذكاء الاصطناعي",
heroTitle: "إنشاء تقرير الموقع",
heroSub: "يكتب الذكاء الاصطناعي تقريرًا من كل أصل في هذا الموقع: الفحوصات والمهام والمستندات والمخاطر.",
includeAnalysis: "تضمين التحليل",
toggleAnalysisA11y: "تبديل تحليل {{label}}",
generateButton: "إنشاء تقرير",
snapshotComparison: "التقارير السابقة",
latestSnapshotLine: "الأحدث: {{date}}",
previousSnapshotLine: "السابق: {{date}}",
noPreviousSnapshot: "لا يوجد تقرير سابق بعد.",
insightTitle: "ملخص تقرير الموقع",
signalRisk: "المخاطر {{level}} ({{score}}).",
signalHealth: "الصحة {{status}} ({{score}}).",
signalCompliance: "الامتثال {{posture}} ({{score}}).",
signalLatestSnapshot: "آخر تقرير محفوظ: {{date}}.",
signalNoSnapshot: "لم يُحفظ أي تقرير بعد.",
signalAnalysisSelected_one: "تم تحديد نوع تحليل واحد.",
signalAnalysisSelected_other: "تم تحديد {{count}} نوع تحليل.",
signalSnapshotsAvailable_one: "يتوفر تقرير محفوظ واحد.",
signalSnapshotsAvailable_other: "يتوفر {{count}} تقرير محفوظ.",
signalNoSnapshotsAvailable: "لا توجد تقارير محفوظة بعد.",
metricSnapshots: "التقارير المحفوظة",
sourceGenerated: "كتبه الذكاء الاصطناعي",
sourceSnapshot: "آخر تقرير محفوظ",
sourceSetup: "لم يُنشأ بعد",
executiveSummary: "الملخص التنفيذي",
riskHealthCompliance: "المخاطر / الصحة / الامتثال",
riskLine: "المخاطر: {{level}} ({{score}})",
healthLine: "الصحة: {{status}} ({{score}})",
complianceLine: "الامتثال: {{posture}} ({{score}})",
maintenanceService: "الصيانة والخدمة",
recommendations: "التوصيات",
recommendationLine: "- {{recommendation}}",
noReportYet: "لا يوجد تقرير للموقع بعد. اضغط إنشاء التقرير.",
sources: "المصادر",
sourceLine: "- [{{sourceType}}] {{title}}",
signalAnalysisSelected_zero: "لم يُحدد أي نوع تحليل.",
signalAnalysisSelected_two: "تم تحديد نوعي تحليل.",
signalAnalysisSelected_few: "تم تحديد {{count}} أنواع تحليل.",
signalAnalysisSelected_many: "تم تحديد {{count}} نوع تحليل.",
signalSnapshotsAvailable_zero: "لا توجد تقارير محفوظة.",
signalSnapshotsAvailable_two: "يتوفر تقريران محفوظان.",
signalSnapshotsAvailable_few: "تتوفر {{count}} تقارير محفوظة.",
signalSnapshotsAvailable_many: "يتوفر {{count}} تقريرًا محفوظًا.",
},
edit: {
  parentLoopBody: "لا يمكن وضع الموقع داخل نفسه أو داخل أحد مواقعه.",
  parentLoopTitle: "اختر موقعاً آخر",
  updateFailedBody: "لم يتم حفظ تغييراتك. تحقق من اتصالك وحاول مرة أخرى.",
  saved: "تم حفظ {{name}}.",
pageTitle: "تحرير الموقع",
unsavedGuardMessage: "لديك تعديلات غير محفوظة على هذا الموقع. هل تريد المغادرة وفقدانها؟",
unsavedGuardDiscard: "مغادرة",
unsavedGuardKeep: "استمر في التحرير",
updateFailedTitle: "تعذر تحديث الموقع",
loadErrorTitle: "تعذر تحميل هذا الموقع",
loadErrorWithMessage: "{{message}}. تحقق من اتصالك وحاول مرة أخرى.",
loadErrorGeneric: "تحقق من اتصالك وحاول مرة أخرى.",
save: "حفظ",
archiveConfirmMessage: "سيُخفى من مواقعك. تبقى الأصول في مكانها. ستجده ضمن المؤرشفة في المواقع ويمكنك استعادته.",
siteNameA11y: "اسم الموقع",
codeA11y: "الرمز",
descriptionA11y: "الوصف",
archiveSite: "أرشفة الموقع",
    floorArea: "المساحة (م²)",
    floorAreaPlaceholder: "مثال: 2400",
    floorAreaHint: "تُستخدم في ESG للطاقة والكربون لكل م². اتركها فارغة إن لم تكن معروفة.",
    floorAreaInvalid: "أدخل المساحة رقمًا بالأمتار المربعة.",
},
intake: {
pageTitle: "الإبلاغ عن مشكلة",
errorTitleMissing: "أخبرنا بما يحدث.",
errorDescriptionMissing: "أضف بعض التفاصيل حتى يتمكن الفريق من المساعدة.",
errorNameMissing: "اسمك مطلوب.",
errorEmailInvalid: "أدخل عنوان بريد إلكتروني صالحًا.",
errorPhoneInvalid: "أدخل رقم هاتف صالحًا للدولة المحددة.",
errorContactMissing: "أضف بريدًا إلكترونيًا أو هاتفًا حتى يتمكن الفريق من الرد.",
uploadFailed: "لم نتمكن من تحميل صورك. قم بإزالتها أو حاول مرة أخرى.",
errorNotAvailable: "هذا الرابط لا يقبل الطلبات حاليًا.",
errorSubmitterDetailsRequired: "يرجى إضافة اسمك والبريد الإلكتروني أو رقم الهاتف.",
errorSubmitGeneric: "تعذر إرسال طلبك. يرجى المحاولة مرة أخرى.",
contactLabel: "جهة اتصال",
addressLabel: "العنوان",
linkIncompleteTitle: "الرابط غير مكتمل",
linkIncompleteBody: "الرابط الذي فتحته يفتقد مرجع الأصول الخاص به. حاول مسح رمز QR مرة أخرى.",
unavailableTitle: "هذا الرابط لا يقبل الطلبات",
unavailableBody: "الإبلاغ متوقف لهذا الرمز أو أن الرمز قديم. أخبر المسؤولين عن المكان، مثل الاستقبال أو مكتب الموقع.",
sentTitle: "شكرًا — استلمنا بلاغك",
sentBody: "استلم {{company}} بلاغك. سيتواصلون معك عبر البريد أو الهاتف إذا احتاجوا شيئًا. يمكنك إغلاق هذه الصفحة.",
fallbackTeam: "الفريق",
reportAnother: "أبلغ عن مشكلة أخرى",
reportAnotherA11y: "أبلغ عن مشكلة أخرى بخصوص هذا الأصل",
beforeYouSend: "قبل أن ترسل",
deflectTitle: "قد يؤدي هذا إلى إصلاح المشكلة بشكل أسرع",
deflectIntro_one: "وجدنا دليلًا لهذا الأصل قد يجيب بالفعل على مشكلتك. ألقِ نظرة سريعة — إن ساعدك، فقد انتهى الأمر. وإن لم يفعل، أرسل طلبك أدناه.",
deflectIntro_other: "وجدنا {{count}} أدلة لهذا الأصل قد تجيب بالفعل على مشكلتك. ألقِ نظرة سريعة — إن ساعدتك، فقد انتهى الأمر. وإن لم تفعل، أرسل طلبك أدناه.",
kbFaq: "أسئلة شائعة",
kbHowTo: "كيفية الاستخدام",
collapseGuideA11y: "طي {{title}}",
expandGuideA11y: "قم بتوسيع {{title}}",
openFullGuide: "افتح الدليل الكامل",
openGuideA11y: "فتح الدليل: {{title}}",
stillSend: "أرسل طلبي رغم ذلك",
stillSendA11y: "أرسل طلبي على أي حال",
backToRequest: "العودة إلى طلبي",
backToRequestA11y: "العودة لتعديل طلبي",
formTitle: "أخبرنا بما يحدث",
introWithAsset: "أنت تبلغ عن مشكلة في {{assetName}}. ",
introBody: "سيرى الفريق رسالتك ويتصل بك - أضف اسمك وبريدك الإلكتروني أو رقم هاتفك حتى يتمكنوا من الوصول إليك.",
fieldWhatsHappening: "ماذا يحدث؟",
titlePlaceholder: "ملخص من سطر واحد - على سبيل المثال \"لا يوجد ماء ساخن في الوحدة 3\"",
titleA11y: "ماذا يحدث (مطلوب)",
fieldDetails: "التفاصيل",
detailsPlaceholder: "صِف المشكلة — ما الخطأ، وأين، ومنذ متى",
detailsA11y: "التفاصيل (مطلوب)",
fieldPhotos: "الصور",
photosOptionalHint: "(اختياري، حتى 2)",
removePhotoA11y: "إزالة الصورة {{index}}",
addPhotoA11y: "إضافة صورة",
addPhotoLabel: "إضافة صورة",
fieldYourName: "اسمك",
namePlaceholder: "ليعرفوا من يساعدون",
nameA11y: "اسمك (مطلوب)",
fieldEmail: "البريد الإلكتروني",
emailPlaceholder: "حتى يتمكنوا من الرد",
fieldPhone: "الهاتف",
phonePlaceholder: "في حالة الحاجة للاتصال",
contactHint: "سوف نستخدم هذا فقط للرد على بلاغك.",
sending: "جارٍ الإرسال…",
checkingFix: "جارٍ التحقق من وجود حل سريع...",
sendRequest: "إرسال الطلب",
deflectIntro_zero: "لم نعثر على أدلة لهذا الأصل. أرسل طلبك أدناه.",
deflectIntro_two: "وجدنا دليلين لهذا الأصل قد يجيبان بالفعل على مشكلتك. ألقِ نظرة سريعة — إن ساعداك، فقد انتهى الأمر. وإن لم يفعلا، أرسل طلبك أدناه.",
deflectIntro_few: "وجدنا {{count}} أدلة لهذا الأصل قد تجيب بالفعل على مشكلتك. ألقِ نظرة سريعة — إن ساعدتك، فقد انتهى الأمر. وإن لم تفعل، أرسل طلبك أدناه.",
deflectIntro_many: "وجدنا {{count}} دليلًا لهذا الأصل قد يجيب بالفعل على مشكلتك. ألقِ نظرة سريعة — إن ساعدك، فقد انتهى الأمر. وإن لم يفعل، أرسل طلبك أدناه.",
},
knowledge: {
  goToAssets: "الانتقال إلى الأصول",
backButton: "رجوع",
title: "قاعدة المعرفة",
subtitle: "ابحث في أصولك",
unknownAsset: "أصل غير معروف",
anyAsset: "أي أصل",
moreAssetsSummary: "{{first}}، {{second}} +{{count}} أخرى",
openItemA11y: "فتح {{title}}، {{kind}} على {{asset}}",
untitledItemA11y: "عنصر معرفي",
untitled: "بدون عنوان",
searchPlaceholder: "ابحث في المعرفة",
refineResults: "تصفية النتائج",
refineTypeLabel: "النوع",
refineAssetLabel: "أصل",
assetSummaryA11y: "الأصول: {{summary}}",
removeAssetA11y: "إزالة {{name}}",
signInTitle: "سجّل الدخول للبحث في قاعدة معارفك",
signInBody: "انتهت صلاحية جلستك، لذا تعذر البحث عن أي شيء. سجِّل الدخول مرة أخرى للمتابعة.",
searchErrorTitle: "تعذّر إجراء هذا البحث",
tryAgain: "إعادة المحاولة",
noMatchesTitle: "لا توجد نتائج مطابقة",
noMatchesBody: "لا نتائج. جرّب كلمات أخرى أو أضفها: افتح الأصل وانتقل إلى المعرفة واضغط إضافة.",
noFilterMatchesTitle: "لا شيء يطابق عوامل التصفية هذه",
filteredEmptyBody_one: "طابقت نتيجة واحدة البحث لكنها لا تطابق الأصل أو النوع الذي اخترته.",
filteredEmptyBody_other: "طابقت {{count}} نتيجة البحث لكن لا شيء منها يطابق الأصل أو النوع الذي اخترته.",
introTitle: "ابحث في قاعدة معارفك",
introBody: "ابحث عن الإرشادات والأسئلة الشائعة والملاحظات والملفات والروابط في كل الأصول. اكتب حرفين على الأقل. لإضافة معرفة، افتح أصلًا وانتقل إلى المعرفة واضغط إضافة.",
shareOpenLinkFailedTitle: "تعذّر فتح الرابط",
shareInvalidLink: "رابط غير صالح",
shareTimeoutMessage: "يستغرق تحميل هذه المكتبة المشتركة وقتًا طويلاً. تحقق من اتصالك وحاول مرة أخرى.",
shareLoadFailed: "تعذر تحميل المعرفة المشتركة",
shareUnableToLoad: "غير قادر على التحميل",
shareEmptyTitle: "لا يوجد شيء للعرض",
shareEmptyBody: "ربما تم إلغاء هذه المشاركة، أو لم يتم نشر أي مقالات لها بعد.",
shareOpenLink: "فتح الرابط",
shareOpenFile: "فتح الملف",
shareClose: "إغلاق",
filteredEmptyBody_zero: "لا نتائج طابقت البحث.",
filteredEmptyBody_two: "طابقت نتيجتان البحث لكن لا شيء منهما يطابق الأصل أو النوع الذي اخترته.",
filteredEmptyBody_few: "طابقت {{count}} نتائج البحث لكن لا شيء منها يطابق الأصل أو النوع الذي اخترته.",
filteredEmptyBody_many: "طابقت {{count}} نتيجة البحث لكن لا شيء منها يطابق الأصل أو النوع الذي اخترته.",
},
  documents: {
    title: "مستندات الموقع",
    sub: "مستندات المبنى كله، مثل شهادة EPC أو DEC. تبقى مستندات كل أصل على الأصل نفسه.",
    add: "إضافة مستند",
    open: "فتح",
    edit: "تعديل",
    archive: "أرشفة",
    cancel: "إلغاء",
    archiveTitle: "أرشفة هذا المستند؟",
    archiveBody: "يخرج {{title}} من هذه القائمة. يبقى الملف والسجل محفوظين.",
    archiveFailed: "تعذّرت أرشفة المستند. حاول مرة أخرى.",
    loadFailed: "تعذّر تحميل المستندات.",
    retry: "حاول مرة أخرى",
    emptyTitle: "لا توجد مستندات للموقع بعد",
    emptyBody: "أضف هنا شهادات المبنى، مثل شهادة EPC أو DEC.",
    validUntil: "صالحة حتى {{date}}",
    expired: "انتهت في {{date}}",
  },
};
